import styled from 'styled-components';

export const StyledCallHeader = styled.div`
  position: relative;
  z-index: 2;
  text-align: center;
  h5 {
    margin: 0;
    color: #c6c9d1;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    color: #ffffff;
  }
`;
